import React, { Component } from "react";
import {
  Wrapper,
  Card,
  CardBody,
  PrimaryButton,
  Scroll
} from "app/NativeComponents/common";
import { CardLabel } from "app/NativeComponents/snippets";

import { openUrl, AppConfig } from "app/NativeActions";

import User from "./User";

class Users extends Component {
  render() {
    if (this.props.users.length > 0) {
      return (
        <Wrapper>
          <Card>
            <CardLabel
              title={"My Registered Users:"}
              icon={"group"}
              hasButton={false}
              onPress={() => {}}
              hasBorder={true}
            />
            <Scroll style={{ maxHeight: 711 }}>
              {this.props.users.map(function (user, i) {
                return <User key={i} user={user} />;
              })}
            </Scroll>
          </Card>
          <Card style={{ borderRadius: 30, overflow: "hidden" }}>
            <PrimaryButton
              onPress={() => {
                openUrl(
                  AppConfig().api_url +
                    "v1/partner/?token=" +
                    this.props.token +
                    "&export_type=csv"
                );
              }}
            >
              Export Sign Ups
            </PrimaryButton>
          </Card>
        </Wrapper>
      );
    }

    return <Wrapper />;
  }
}

export default Users;
